<template>
  <g>
    <!-- transparent stroke configuration-->
    <template v-if="configuration">
      <mce-line-plot
        v-for="(data, line_ndx) in linePlots.props.data"
        :class="[lineStyle]"
        :key="'line_trans' + line_ndx"
        color="transparent"
        :line-weight="20"
        :data="data"
        :mouse="mouse"
        :domain-x="domainX"
        :domain-y="domainY"
        :range-x="rangeX"
        :range-y="rangeY"
        scale-type-x="time"
        scale-type-y="linear"
        @click.native="configuration ? onSelect(line_ndx) : null"
        @mouseover.native="hovered = line_ndx"
        @mouseleave.native="hovered = null"
        @mousemove-plot="onHover(line_ndx, $event)"
        @mouseleave-plot="!configuration ? (focusedData = null) : null"
      ></mce-line-plot>
    </template>
    <!-- line plots -->
    <mce-line-plot
      v-for="(data, line_ndx) in linePlots.props.data"
      :key="'line_' + line_ndx"
      :class="[
        lineStyle,
        'pf-line-plot',
        {
          'pf-line-plot--not-focused': notHovered(data, line_ndx) || notSelected(data, line_ndx),
        },
      ]"
      :color="linePlots.props.color[line_ndx]"
      :dashed="linePlots.props.dashed ? linePlots.props.dashed[line_ndx] : false"
      :show-outline="linePlots.props.showOutline ? linePlots.props.showOutline[line_ndx] : false"
      :line-weight="linePlots.props.lineWeight ? linePlots.props.lineWeight[line_ndx] : 2"
      :data="data"
      :mouse="mouse"
      :domain-x="domainX"
      :domain-y="domainY"
      :range-x="rangeX"
      :range-y="rangeY"
      v-bind="linePlots.props"
      @click.native="configuration ? onSelect(line_ndx) : null"
      @mouseover.native="hovered = line_ndx"
      @mouseleave.native="hovered = null"
      @mousemove-plot="onHover(line_ndx, $event)"
      @mouseleave-plot="!configuration ? (focusedData = null) : null"
    ></mce-line-plot>
    <mce-guidelines v-show="mouse && !configuration" :data="guides"></mce-guidelines>
  </g>
</template>

<script>
  import MceLinePlot from '@mce/line-plot';
  import MceGuidelines from '@mce/guidelines';

  export default {
    name: 'TimeSeriesLine',
    props: {
      configuration: Boolean,
      focused: String,
      mouse: Object,
      plotIndex: Number,
      plots: Array,
      rangeX: Array,
      rangeY: Array,
      domainX: Array,
      domainY: Array,
    },
    components: {
      MceLinePlot,
      MceGuidelines,
    },
    computed: {
      lineStyle() {
        const obj = {};

        obj['pf-line-plot--config'] = this.configuration;

        return obj;
      },
      linePlots() {
        return this.plots[this.ndx];
      },
      noSelection() {
        return this.plotIndex === null || this.plotIndex === '';
      },
      guides() {
        if (!this.guideData) {
          return [];
        }

        const { _closestPoint } = this.guideData;

        return [
          {
            x1: _closestPoint.x,
            x2: _closestPoint.x,
            y1: 0,
            y2: this.rangeY[0],
          },
        ];
      },
    },
    data() {
      return {
        ndx: 1,
        currentIndex: null,
        mouseData: [],
        nearest: 999999,
        indexData: [],
        guideData: null,
        hovered: null,
      };
    },
    methods: {
      notHovered(data, ndx) {
        return (
          (this.noSelection && this.focused && !data[data.length - 1].id.includes(this.focused)) ||
          (!this.configuration && ndx !== this.hovered && this.hovered) ||
          (this.configuration &&
            this.noSelection &&
            this.hovered !== null &&
            !`${ndx}`.includes(this.hovered))
        );
      },
      notSelected(data, ndx) {
        return (
          this.configuration &&
          !this.noSelection &&
          !`${ndx}`.includes(this.hovered) &&
          !`${ndx}`.includes(this.plotIndex) &&
          !data[data.length - 1].id.includes(this.focused)
        );
      },
      onHover(ndx, ev) {
        const { _dataIndex, _closestPoint } = ev.data;
        const { offsetX } = ev.position;
        const diff = Math.abs(_closestPoint.x - offsetX);

        this.nearest = Math.min(diff, this.nearest);

        if (diff === this.nearest) {
          this.currentIndex = _dataIndex;
        }

        this.indexData[ndx] = { _dataIndex, ev };

        this.guideData = _dataIndex === this.currentIndex ? ev.data : this.guideData;

        if (ndx === this.linePlots.props.data.length - 1) {
          this.indexData.forEach((item, pos) => {
            const { value } = item.ev.data;
            if (this.indexData[pos]._dataIndex === this.currentIndex) {
              this.mouseData[pos] = { value };
              this.mouseData.title = value.x;
            } else {
              this.mouseData[pos] = { value: { y: '—' } };
            }
          });

          this.$emit('mousemove-plot', this.mouseData);

          this.currentIndex = null;
          this.nearest = 999999;
        } else {
          this.mouseData = [];
          this.mouseData.length = 0;
        }
      },
      onSelect(ndx) {
        // TODO: Improve Line selection precision
        this.$emit('pflineplot', {
          plots: 1,
          ndx,
        });
      },
    },
  };
</script>
<style lang="scss">
  @import '@mce/visual-language';

  .pf-line-plot {
    @include mce-animate-focus();

    &--config {
      path {
        cursor: pointer;
      }
    }
  }
</style>
